<template>
  <div class="header">
    <div class="top-wrapper">
       <div class="fl"><em class="iconfont"  @click="$router.go(-1)">&#xe64f;</em></div>
       <div class="fr">
         <input class="input" v-if="showInput" v-model="keyword" />
         <em class="iconfont collect" :class="{'active':keyword}"  @click="toggleKeyword">&#xe6cb;</em>
         <em class="iconfont collect" :class="{'active':store.is_favorate}"  @click="toggleFavorite" v-html="favoriteIco"></em>
       </div>
    </div>
    <div class="content-wrapper">
      <div class="avatar">
        <img :src="store.store_avatar">
      </div>
      <div class="content">
        <div class="title">
          <span class="name">{{store.store_name}}</span>
        </div>
        <div class="description">
          <!-- {{ $t('store.average_time', [store_info.duration || '']) }} -->
        </div>
        <div v-if="(store.is_platform_store && config.business_licence) || store.business_licence_number_electronic" @click="imageVisible=true"><i class="iconfont">&#xe621;</i></div>
      </div>
    </div>
    <div class="background">
      <img v-if="store.store_logo" v-lazy="store.store_logo" width="100%" height="100%">
      <img v-else v-lazy="store.store_logo" width="100%" height="100%">
    </div>
    <mt-popup v-model="imageVisible" popup-transition="popup-fade" class="middle-popup">
      <img v-if="store.business_licence_number_electronic" :src="store.business_licence_number_electronic">
      <img v-if="store.is_platform_store && config.business_licence" :src="config.business_licence">
    </mt-popup>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapState, mapActions, mapGetters } from 'vuex'
import { addFavoriteStore, delFavoriteStore } from '../../../api/memberFavorite'
export default {
  name: 'StoredetailHeader',
  props: {
    store: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      keyword: this.$route.query.keyword,
      showInput: false,
      imageVisible: false
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      store_info: state => state.goodsdetail.storeInfo
    }),
    favoriteIco () {
      return this.store.is_favorate ? '&#xe64d;' : '&#xe64e;'
    }
  },
  watch: {
    store: function (store) {
      if (this.store.is_platform_store) {
        this.fetchConfig({}).then(
          response => {
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    toggleKeyword () {
      if (!this.showInput) {
        this.showInput = true
      } else {
        this.showInput = false
        this.$router.replace({ name: 'HomeStoredetail', query: { id: this.store.store_id, keyword: this.keyword } })
        window.location.reload()
      }
    },
    toggleFavorite () {
      if (!this.store.is_favorate) {
        addFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      } else {
        delFavoriteStore(this.store.store_id).then(
          response => {
            Toast(response.message)
            this.store.is_favorate = !this.store.is_favorate
          },
          error => {
            Toast(error.message)
          }
        )
      }
    }
  }
}
</script>

<style scoped>
  .header {background: #f4c41e;color: #fff;overflow: hidden;position: relative;background-position: center;background-size: auto 100%; border-radius: 0 0 30px 30px}
  .header .top-wrapper{height:2rem;width:100%;display: flex}
  .header .top-wrapper .fl{margin-left:.5rem;}
  .header .top-wrapper .fl em{line-height:2rem;display: block;}
  .header .top-wrapper .fr{flex:1;margin-right:.5rem;font-size: 0;text-align: right;position: relative}
  .header .top-wrapper .fr em{line-height:2rem;margin-left:.5rem;font-size:1rem;}
  .header .top-wrapper .fr .collect{font-size:1.2rem;}
  .header .top-wrapper .fr .collect.active{color: #ff4230}
  .header .top-wrapper .fr .input{width:60%;background: #fff;height: 1.25rem;line-height: 1.25rem;vertical-align:top;position:relative;top:.5rem;border-radius:.2rem;text-align: center;font-size: .7rem}
  .header .content-wrapper {-ms-flex-align: center;-webkit-box-align: center;align-items: center;display: -webkit-box;display: -ms-flexbox;display: flex;padding:.5rem 1rem 1rem 1rem;position: relative;}
  .header .content-wrapper .avatar {-ms-flex: 0 0 4rem;-webkit-box-flex: 0;flex: 0 0 4rem;margin-right:1.2rem;width:4rem;}
  .header .content-wrapper .avatar img {border-radius: 0.1rem;width:4rem;height:4rem;}
  .header .content-wrapper .content {-ms-flex: 1;-webkit-box-flex: 1;flex: 1;position:relative;}
  .header .content-wrapper .content .title {-ms-flex-align: center;-webkit-box-align: center;align-items: center;display: -webkit-box;display: -ms-flexbox;display: flex;margin-bottom:.4rem;}
  .header .content-wrapper .content .title .name {font-size:.8rem; font-weight: 700; word-break: keep-all;}
  .header .content-wrapper .content .description {font-size:.7rem;line-height:.8rem;margin-bottom:.4rem;}
  .header .background {background:#2c3b53;-webkit-filter: blur(0.5rem);filter: blur(0.5rem);height: 100%;left: 0;position: absolute;top: 0;width: 100%;z-index: -1;}
  .middle-popup{width:80%}
  .middle-popup img{max-width:100%}
</style>
